import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'

const entity = {
  imageUrl: {},
  title: {},
  contentMD: {},
  longImageUrl: {},
  active: {},
  clickCount: {},
  viewCount: {},
  startDate: {
    header: false,
    type: IKDataEntity.Types.Date,
    formConfig: {
      required: false
    }
  },
  endDate: {
    header: false,
    type: IKDataEntity.Types.Date,
    formConfig: {
      required: false
    }
  },
  ctr: {}
}

const path = 'merchant-promotions'
const config = {
  load: async function (filter) {
    return (await hillo.get(cloudV2Url + path, {
      blId: GlobalConfig.blId
    }))
  },
  add: async function (item) {
    item.blId = GlobalConfig.blId
    return (await hillo.jsonPost(cloudV2Url + path, {
      ...item
    })).content
  },
  edit: async function (item) {
    return (await hillo.jsonPost(cloudV2Url + path + '/' + item.id + '/update', {
      ...item
    })).content
  },
  remove: async function (id) {
    return (await hillo.jsonPost(cloudV2Url + path + '/' + id + '/delete', {
      blId: GlobalConfig.blId
    }))
  }
}

export default IKDataEntity.ModelFactory(entity, config)
